module.exports = __webpack_public_path__ + "media/images/stock_groups/e158-38bdc9e6146fc12f1ea3312d7b23fe98.svg";